import React from "react";
import {
  Route,
  Switch,
  useRouteMatch,
  NavLink as Links,
} from "react-router-dom";
import Error404 from "../../Components/Error404";
import Entries from "./Report/Entries";
import Deductions from "./Report/Deductions";
export default function StockReport() {
  const { url } = useRouteMatch();
  return (
    <div className="p-0 m-0">
      <header className="header no-border">
        <div className="header-info mb-0">
          <div className="left">
            <h2 className="header-title">
              <strong>Stock Report</strong>
            </h2>
          </div>
        </div>
        <div className="header-action">
          <nav className="nav">
            <Links className="nav-link" activeClassName="active" to={`${url}`}>
              Entires
            </Links>
            <Links
              className="nav-link"
              activeClassName="active"
              to={`${url}/Deductions`}
            >
              Deductions
            </Links>
          </nav>
        </div>
      </header>

      <Switch>
        <Route path={url} exact component={Entries} />
        <Route path={`${url}/Deductions`} exact component={Deductions} />
        <Route path="*">
          <Error404 />
        </Route>
      </Switch>
    </div>
  );
}
